export default __webpack_public_path__ + "static/media/s2.f289e7ea.png";